<template>
  <v-dialog
    v-model="shown"
    max-width="967"
    @click:outside="cancel"
  >
  <div v-if="asyncDataStatus_ready" class="col-full push-top popup">
    <h2>
      Dodajte nov artikel:
    </h2>
    <ArticleForm
      @save="save"
      @cancel="cancel"
      :groups="groups"
      :categories="categories"
      :articles="articles"
      :article="article"
      ref="form"
    />
  </div>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import ArticleForm from '@/components/ArticleForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  data () {
    return {
      shown: false
    }
  },
  components: {
    ArticleForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    article: {
      default: null,
      type: Object
    }
  },
  computed: {
    groups () {
      return objectToArray(this.$store.state.groups.items)
    },
    categories () {
      return objectToArray(this.$store.state.categories.lastLevelItems)
    },
    articles () {
      return objectToArray(this.$store.state.articles.items)
    }
  },
  methods: {
    ...mapActions('articles', { saveItem: 'saveItem', loadArticles: 'loadItems' }),
    ...mapActions('groups', { loadGroups: 'loadItems' }),
    ...mapActions('categories', { loadCategories: 'loadLastLevelItems' }),
    save ({ data, repeat = false }) {
      // const redirect = repeat ? null : 'MyCompanyArticles'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          this.$refs.form.saveAndRepeatClear()
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          // if (redirect) {
          // this.$router.push({ name: redirect })
          if (repeat) {
            this.article = null
            this.article = data
            this.$emit('refreshRepeat', data)
          } else {
            this.cancel(data)
          }
        })
    },
    cancel (data) {
      // this.$router.push({ name: 'MyCompanyArticles' })
      this.shown = false
      this.$emit('zapri', data)
    }
  },
  created () {
    this.shown = false
    Promise.all([
      this.loadGroups(),
      this.loadCategories(),
      this.loadArticles()
    ])
      .then(items => {
        this.asyncDataStatus_fetched()
        this.shown = true
      })
  }
}
</script>

<style lang="scss" scoped>
.popup {
  background-color: #fff;
  padding: 1rem;
}
</style>
